export default "__VITE_ASSET__DP_rxu0g__"